import { prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var initiateSession = function initiateSession(axios, hugggId) {
  return axios.post(urls.apiV3('/bank-payments/claim-sessions'), {
    hugggId: hugggId
  }).then(prop('data'));
};
var getClaimStatus = function getClaimStatus(axios, hugggId) {
  return axios.get(urls.apiV3("/bank-payments/claim-sessions/by-huggg/".concat(hugggId))).then(prop('data'));
};
export default {
  initiateSession: withAxios(initiateSession),
  getClaimStatus: withAxios(getClaimStatus)
};